import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { LLMMessageWrapper } from "./LLMMessageWrappers";
import { RoundActionIconButton } from "../../components/Buttons/ActionIconButton/RoundActionIconButton";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
const EditAnswerMarkdownButtons = ({ cancelEditMode, acceptEdit, disabled, }) => {
    return (_jsxs(Box, Object.assign({ sx: {
            display: "flex",
            alignItems: "center",
            position: "sticky",
            left: 0, // Match parent background
        } }, { children: [_jsx(Typography, Object.assign({ variant: "caption", color: " #b3b3b3", sx: { mx: 1 } }, { children: "Edit response" })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Cancel", onClick: cancelEditMode, baseColor: "#ffffff", disabled: disabled }, { children: _jsx(CloseIcon, { sx: { fontSize: "1rem" } }) })), _jsx(RoundActionIconButton, Object.assign({ size: "small", tooltipMsg: "Accept", onClick: acceptEdit, baseColor: "#ffffff", disabled: disabled }, { children: _jsx(CheckIcon, { sx: { fontSize: "1rem" } }) }))] })));
};
export function EditAnswerMarkdown({ answer, acceptAnswerEdit, cancelAnswerEdit, disabled, }) {
    const [editedAnswer, setEditedAnswer] = useState(answer);
    useEffect(() => {
        setEditedAnswer(answer);
    }, [answer]);
    const handleChange = (event) => {
        setEditedAnswer(event.target.value);
    };
    const handleAcceptEdit = () => {
        acceptAnswerEdit(editedAnswer);
    };
    return (_jsxs(_Fragment, { children: [_jsx(LLMMessageWrapper, { children: _jsx(TextField, { sx: {
                        "&.MuiFormControl-root": {
                            width: "100%",
                        },
                    }, InputProps: {
                        sx: {
                            backgroundColor: "#4d4d4d",
                            color: "white",
                            fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                            fontSize: "0.875rem",
                            "& .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                border: "none",
                            },
                        },
                    }, id: "outlined-multiline-flexible", multiline: true, value: editedAnswer, onChange: handleChange, disabled: disabled }) }), _jsx(EditAnswerMarkdownButtons, { cancelEditMode: cancelAnswerEdit, acceptEdit: handleAcceptEdit, disabled: disabled })] }));
}
